module.exports = __webpack_public_path__ + "static/media/uwaterloo.64ed02de.67669d87.svg";